import React, { useRef, useState } from 'react'
import {  Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from 'react-query'
import {  useLocation, useNavigate, useParams } from 'react-router-dom'
import {  blogs } from "../../Routes/routingConsts";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import InputControl from '../../components/InputControl'
import Swal from 'sweetalert2'
import ButtonWithLoader from '../../components/ButtonWithLoader/ButtonWithLoader'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import  { CKEditor } from '@ckeditor/ckeditor5-react'
import  { components } from 'react-select'
import { getFormData } from '../../functions/common'
import { Spinner } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { ReactComponent as SelectImg } from '../../assets/images/selectimg.svg'
import defaultimages from '../../assets/images/blog_custom_icon.png'
import { ReactComponent as LeftArrowIcon } from '../../assets/images/left-arrow-icon.svg'
import "./editor.scss"
const getlocation = (datalist) => {
    return requestApi
        .post(`/user-home/location`, { search:   datalist })
        .then((res) => {
            return res.data
        })
}

const fetchQuery = (query) => {
    return requestApi
        .post(`/user-home/job-skill`, {
            search: query
        })
        .then((res) => {
            return res.data
        })
}
export async function addnewSkill(skillname) {
    return await requestApi.post('/employer/new-add-skill', {
        name: skillname
        // temp_skill: true
    })
}

const CreateNewBlog = () => {
  
    const [show, setShow] = useState(false)
    const { blogId } = useParams()
    const { state } = useLocation()
    const navigate = useNavigate()


    
    const { Option } = components
    const [editorState, setEditorState] = useState()
    const skillField = useRef(null)
    const locationField = useRef(null)
    const industryField = useRef(null)
    const [userSkills, setuserSkills] = useState([])
    const [skill, setSkill] = useState('')
    const [changeDataLocation, setChangeDataLoaction] = useState('')
    const [ckeditordata, setckeditordata] = useState('')

    const handleCancleButton = () => {
        // if (state === 'dashBoardJobOpening') {
        //     navigate(home)
        // } else {
            navigate(blogs)
        // }
    }

    const IconOption = (props) => {
        const { label, industryName } = props.data

        return (
            <Option {...props}>
                <div className="react-select-option">{industryName}</div>
            </Option>
        )
    }
    const onEditorStateChange = (e) => {
        setEditorState(e)
    }
    const handleClose = () => {
        setShow(false)
        skillreset()
        setSkill('')
    }
    const addnewmutation = useMutation(addnewSkill, {
        onSuccess: ({ data }) => {
            setValue('keywords', [
                ...userSkills,
                { name: data?.data?.name, _id: data?.data?._id }
            ])
            setuserSkills((prev) => {
                return [
                    ...prev,
                    { name: data?.data?.name, _id: data?.data?._id }
                ]
            })

            handleClose()
            if (userSkills.length === 0) {
                clearErrors('keywords')
            }

            // addmutation.mutate(data?.data?._id)
            // setsearchedVal('')
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })
    const [tagData, setTagData] = useState([]);
    console.log(tagData, 'tagData')
    const handleOnSubmit = (data) => {
        setTagData((prevTagData) => [...prevTagData, data.tags]);
        handleClose();
      };

    const [inputValue, setInputValue] = useState('');
    const [valuesArray, setValuesArray] = useState([]);
    const createJobOpeningvalidation = yup.object({
        blogTitle: yup.string().trim().required('Please enter blog Title.'),
        conclusion: yup.string().trim().required('Please enter conclusion.'),
        description: yup
            .string()
            .trim()
            .required('Please enter blog description'),
        videoUrl: yup.string().trim().url('Invalid URL'),
        tagsdata:yup
        .mixed(),
         tags:yup
        .mixed().test("please add Tag/s","please add Tag/s",function(value){
            console.log(this.parent.tagsdata,"this.parent.tagsdata",value)
            return this.parent.tagsdata?.length>0
        }),
        
    })
    const {
        getFieldState,
        control,
        register,
        watch,
        clearErrors,
        handleSubmit,
        reset,
        setError,
        setValue,
        formState: { errors ,submitCount}
    } = useForm({
        resolver: yupResolver(createJobOpeningvalidation),

    })
    console.log(submitCount, 'submitCount====>')

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleEnterKeyPress = (event) => {
        if (event.key === 'Enter' && inputValue.trim() !== '') {
          // Add the input value to the array
          if ([...valuesArray, inputValue.trim()].length>0) {
            clearErrors("tags")
          }
          setValuesArray((prevValues) => [...prevValues, inputValue.trim()]);
          console.log([...valuesArray, inputValue.trim()],"[...valuesArray, inputValue.trim()]")
          setValue("tagsdata",[...valuesArray, inputValue.trim()])
          // Clear the input field after adding the value
          setInputValue('');
        }
      };


    const { data: country, isLoading: countryLoading } = useQuery({
        queryKey: ['country', changeDataLocation],
        queryFn: () => getlocation(changeDataLocation),
        enabled: !!changeDataLocation,
        onSuccess: (data) => {}
    })

    const mySkillValidation = yup.object({
        tags: yup
            .string()
            .trim()
            .max(25, 'Must be at max 25 characters')
            .required('Please enter tag')
    })
    const {
        register: skillregister,
        reset: skillreset,
        setError: skilsetError,
        setValue: skillsetValue,
        clearErrors: skillclearErrors,
        handleSubmit: skillhandleSubmit,
        formState: { errors: skillerrors }
    } = useForm({ resolver: yupResolver(mySkillValidation) })
    async function getachivedDetail({ queryKey }) {
        return await requestApi
            .post(
                `/job-opening/view`,
                { blogId: state },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const {
        data: getAcrchived,
        isLoading: viewOnCopy,
        isFetching
    } = useQuery({
        queryKey: ['Archived'],
        queryFn: getachivedDetail,
        enabled: !!state,
        onSuccess: (data) => {
            reset({
                jobTitle: data.data.jobTitle,
                industry: {
                    industryId: data?.data?.industry,
                    industryName: data?.data?.industryName
                },
                location: {
                    cityId: data?.data?.locationId,
                    location: data?.data?.location
                },
                experience:
                    data.data.experience > 1
                        ? `${data.data.experience} Years`
                        : `${data.data.experience} Year`,
                jobType: data.data.jobType,
                // salary: data.data.salary,
                totalOpening: data.data.totalOpening,
                jobStatus: data.data.jobStatus,
                locationType: data.data.locationType,
                keySkill: data.data.keySkill,
                jobDescription: data.data.jobDescription,
                isSalarySpecified: !data?.data?.isSalarySpecified,
                currency: data?.data?.currency ?? '',
                maxSalary: data?.data?.maxSalary ?? null,
                minSalary: data?.data?.minSalary ?? null,
                salaryType: data?.data?.salaryType ?? ''
            })

            setckeditordata(data.data.jobDescription)

            // locationField.current.value = 'data.data.location'
            // setuserSkills(
            //     data.data.keySkill.split(',').map((e) => {
            //         return { name: e }
            //     })
            // )
            // setValue(
            //     'keywords',
            //     data.data.keySkill.split(',').map((e) => {
            //         return { name: e }
            //     })
            // )
        }
    })

    //list category API

    async function categoryList() {
        return await requestApi.post(
            `category/list`,
            { limit: 550 },
            { headers: true }
        )
    }
    const { data: categoryDataList } = useQuery({
        queryKey: ['category'],
        queryFn: () => categoryList('country')
        // enabled: !!userProfile
    })

    const deleteSkill = (id) => {
        setuserSkills((prev) => prev.filter((skill) => skill?._id !== id))
        if (userSkills.length === 1) {
            setError('keywords', 'Please Select Keywords')
        }
    }
    const { data: jobSkills } = useQuery({
        queryKey: ['jobSkill', skill],
        queryFn: () => fetchQuery(skill),
        enabled: !!skill,
        onSuccess: (data) => {}
    })

    let timmer
    const handleChangeSkill = (e) => {
        if (timmer) {
            clearTimeout(timmer)
        }
        timmer = setTimeout(() => {
            setSkill(e.target.value)
        }, 400)
    }

    async function newAddJobOpening(payload) {
        if (blogId) {
            // let industryName = industry
            return await requestApi
                .post(
                    `blog/add-edit`,
                    payload
                )
                .then((res) => {
                    return res.data
                })
        } else {
            return await requestApi
                .post(
                    `blog/add-edit`,
                    payload
                )
                .then((res) => {
                    return res.data
                })
        }
    }
    const mutation = useMutation(newAddJobOpening, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            }).then(() => {
                navigate(blogs)
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })
    //Start Drop down for location////
    const IconOptionLocation = (props) => {
        const { label, location } = props.data

        return (
            <Option {...props}>
                <div className="react-select-option">{location}</div>
            </Option>
        )
    }

    const [userLocation, setUserlocation] = useState([])
    const [searchDeatails, setSearchDeatails] = useState({
        location: ''
    })

    let locationTimmer
    const handleChangeLocation = (e) => {
        if (locationTimmer) {
            clearTimeout(locationTimmer)
        }
        locationTimmer = setTimeout(() => {
            setChangeDataLoaction(e)
            // setChangeDataLoaction(e.target.value)
        }, 400)
    }
    function handleDropDown(fieldValue, fieldName) {
        setUserlocation((prev) => {
            return { ...prev, [fieldName]: JSON.parse(fieldValue) }
        })
    }
    const addLocationData = (selectedSkill, fieldValue, fieldName) => {
        setUserlocation((prev) => {
            return { ...prev, [fieldName]: fieldValue }
        })
        locationField.current.value = ''
    }
    // end Drop Down for location///

    // industry search dropDown /////
    const [userIndustry, setUserIndustry] = useState([])
    const [changeDataIndustry, setChangeDataIndustry] = useState('')

    let industryTimmer
    const handleChangeIndustry = (e) => {
        if (industryTimmer) {
            clearTimeout(industryTimmer)
        }
        industryTimmer = setTimeout(() => {
            setChangeDataIndustry(e.target.value)
        }, 400)
    }

    const addIndustryData = (selectedSkill, fieldValue, fieldName) => {
        setUserIndustry((prev) => {
            return { ...prev, [fieldName]: fieldValue }
        })
        industryField.current.value = ''
    }

    // end industry drop-down /////
    console.log(errors,'errors')
    ///////// view api for data ////
    async function viewJobOpeningData(jobOpening) {
        return await requestApi
            .post(
                `/blog/view`,
                { blogId: jobOpening },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const [imgType, setImgType] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['view-job-profile'],
        queryFn: () => viewJobOpeningData(blogId),
        enabled: !!blogId,
        onSuccess: (data) => {
            setImgType(data?.data?.image)
            console.log(data?.data, 'imgaaaaa')
            reset({
                blogTitle: data?.data?.blogTitle,
                conclusion: data?.data?.conclusion,
                description: data?.data?.description,
                videoUrl: data?.data?.videoUrl,
            })
            setImageUrl(data?.data?.image)
            setValuesArray(data?.data?.tags)
            setTagData(data?.data?.tags)
            setValue('profilePic', data?.data?.image)
        },
        onError: (error) => {
            if(error.message !== null){
                navigate(blogs)
            }
            console.log(error, 'errorerror')
        }
    })

    const addSkill = (selectedSkill) => {
        setuserSkills((prev) => {
            if (
                prev.some((p) => {
                    return p._id === selectedSkill?._id
                })
            ) {
                setValue('keywords', prev)
                return prev
            } else {
                setValue('keywords', [...prev, selectedSkill])
                return [...prev, selectedSkill]
            }
        })

        skillField.current.value = ''
    }
    const customContentStateConverter = (contentState) => {
        // changes block type of images to 'atomic'
        const newBlockMap = contentState.getBlockMap().map((block) => {
            const entityKey = block.getEntityAt(0)
            if (entityKey !== null) {
                const entityBlock = contentState.getEntity(entityKey)
                const entityType = entityBlock.getType()
                switch (entityType) {
                    case 'IMAGE': {
                        const newBlock = block.merge({
                            type: 'atomic',
                            text: 'img'
                        })
                        return newBlock
                    }
                    default:
                        return block
                }
            }
            return block
        })
        const newContentState = contentState.set('blockMap', newBlockMap)
        return newContentState
    }

    function handleCKEditor(event, editor) {
        const data = editor.getData()

        setckeditordata(data)
    }

    const handleDeleteTag = (index) => {
        const arr = [...valuesArray];
        const removedvalue = arr.splice(index, 1);
        console.log(arr,"removedvalue")
        setTagData([...arr]);
        setValuesArray([...arr]);
        setValue("tagsdata",arr)
        if(arr.length === 0 && submitCount>0) {
            setError('tags',{ type: 'custom', message: 'please add Tag/s' })
        }
    }

    const uploadImage = useRef(null)
    const [imageUrl, setImageUrl] = useState(null)
    const [imageErr,setimageErr] = useState('')

    console.log('imageUrl',imageUrl)
    console.log('imageErr',imageErr)

    const handleFileUpload = (e) => {  
        if (
            e.target.files[0].type === 'image/jpg' ||
            e.target.files[0].type === 'image/jpeg' ||
            e.target.files[0].type === 'image/png'
        ) {
            setValue('profilePic', e.target.files[0])
            setImageUrl(URL.createObjectURL(e.target.files[0]))   
            setimageErr('')
        } else {
            setimageErr('Please select .jpeg, .jpg or .png file formate.')
        }
    }

    const [submitValidation, setSubmitValidation] = useState(false);
    const onSubmit = (data) => {

        if(imageUrl !== null){
            const payload = {
                description: data.description,
                blogTitle: data.blogTitle,
                tags: valuesArray,
                conclusion: data.conclusion,
                videoUrl: data?.videoUrl,
                blogImage: data.profilePic
            }
            // if (typeof data.profilePic ==="object") {
            //     payload.blogImage=data.profilePic
            // }
            if (blogId) {
                payload.blogId= blogId
             }
             const formdata = getFormData(payload)
             mutation.mutate(formdata)
            console.log(data, 'data')
           
        }
    }
    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            // const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor: isFocused ? '#002a3a' : null,
                color: isFocused ? 'white' : 'black',
                ':active': {
                    backgroundColor: '#002a3a'
                }
            }
        }
    }


    // useEffect(() => {
    //     const selectElement = document.getElementById('mySelectElement');
    
    //     if (selectElement && (selectElement.tagName === 'SELECT')) {
    //       const choices = new Choices(selectElement);
    //     }
    //   }, []);

// console.log(errors)
    return (
        <div className="sidebar-content">
            {viewOnCopy || isFetching ? (
                <div className="spinner-wrapper">
                    <Spinner animation="border" role="status" className="tdata">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : (
                <>
                    <Form onSubmit={handleSubmit(onSubmit)} onKeyDown={function (e) {
                    if (e.keyCode === 13) {
                        e.preventDefault()
                    }
                }}> 
                        <div className="whitebox">
                           
                            {blogId ? (
                                <div className="title-text">
                                     <span className='back-btn' onClick={()=>navigate(-1)}>
                                     <LeftArrowIcon />
                                     Back
                                     </span>
                                    <h3>Edit Job Opening</h3>
                                </div>
                            ) : (
                                <div className="title-text">
                                     <span   className='back-btn' onClick={()=>navigate(-1)}>
                                        <LeftArrowIcon />
                                        Back</span>
                                    <h3>Create New Opening</h3>
                                </div>
                            )}

                            <div className="createnew-box">
                                <div className="row">

                                <div className="col-12 mb-3">
                                        <div className="profile-image">
                                            {imageUrl === null ? <img src={defaultimages}  style={{ borderRadius: "0" }}/> :
                                            <img src={imageUrl}/>}
                                            <div
                                                className="selectimg"
                                                onClick={() => uploadImage.current.click()}
                                            >
                                                <input
                                                    type="file"
                                                    ref={(event) => {
                                                        register('profilePic')
                                                        uploadImage.current = event
                                                    }}
                                                    accept=".jpg,.png,.jpeg"
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileUpload}
                                                />
                                                <SelectImg />
                                            </div>
                                        </div>
                                        {submitValidation === true && imageUrl === null && <span className="error-message">{"Please select .jpeg, .jpg or .png file formate."}</span>}
                                    </div>

                                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <InputControl
                                                autoFocus="true"
                                                label="Blog Title"
                                                name="blogTitle"
                                                register={register}
                                                error={
                                                    errors?.blogTitle?.message
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <InputControl
                                            label="Video URL"
                                            name="videoUrl"
                                            register={register}
                                            // placeholder='State Name'
                                            error={errors?.videoUrl?.message}
                                        />
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="whitebox">
                            <div className="title-text" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <h3>Tags</h3>
                                <button
                                    type='button'
                                    className="common-btn create"
                                    onClick={() => {
                                        setShow(true)
                                    }}
                                >
                                    Add Tag
                                </button>
                            </div>
                            <div className='tag-area'>
                                {submitValidation === true && tagData?.length === 0 && <span className='error-message' style={{position: 'relative'}}>please add Tag</span>}
                                {tagData.length !== 0 && tagData?.map((item, index) => (
                                    <p className='tag-item' key={index}>{item}<span className='tag-icon' onClick={() => handleDeleteTag(index)}>x</span></p>
                                ))
                            }
                            </div>
                        </div> */}

                        <div className="whitebox">
                            <div className="title-text">
                                <h3>Tags</h3>
                            </div>

                            <div className="createnew-box">
                                <div className="row">

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                                        <div className="mb-3 input-wrapper blog-tag" style={{padding: `${valuesArray.length === 0 ? "0px 10px" : '10px 10px'}`}}>
                                        {valuesArray?.map((item, index) => (
                                            <p className='tag-item' key={index}>{item}<span className='tag-icon' onClick={() => handleDeleteTag(index)}>x</span></p>
                                        ))}
                                            <InputControl
                                                // label="Conclusion"
                                                style={{padding: '0px 15px',display: 'inline-block'}}
                                                name="tags"
                                                // placeholder="Enter Tag Value"
                                                value={inputValue}
                                                onChange={handleInputChange}
                                                onKeyDown={(e) => handleEnterKeyPress(e)}
                                                register={register}
                                                // error={
                                                //     errors?.tags?.message
                                                // }
                                            />
                                        </div>
                                        <span className='error-message' style={{position: 'relative'}}>{errors?.tags?.message}</span>
                                        {/* {submitValidation === true && valuesArray?.length === 0 && <span className='error-message' style={{position: 'relative'}}>please add Tag/s</span>} */}
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="whitebox">
                            <div className="title-text">
                                <h3>Description</h3>
                            </div>
                            <div className="jobdesbox">
                                <div className="createnew-box heightbox" onKeyDown={(e) => e.stopPropagation()}>
                                    <Controller
                                        control={control && control}
                                        name={'description'}
                                        render={({
                                            field: {
                                                value,
                                                onChange: ckEditoronchange
                                            }
                                        }) => (
                                            <CKEditor
                                                data={value}
                                                editor={ClassicEditor}
                                                config={{
                                                    removePlugins: [
                                                        'EasyImage',
                                                        'ImageUpload',
                                                        'MediaEmbed'
                                                    ],
                                                    link: {
                                                        addTargetToExternalLinks: true
                                                    }
                                                }}
                                                onReady={(editor) =>
                                                    // data?.data?.jobDescription
                                                    console.log(editor, 'hello')
                                                }
                                                onChange={(event, editor) => {
                                                    const data =
                                                        editor.getData()
                                                    ckEditoronchange(data)
                                                }}
                                            />
                                        )}
                                    />

                                    <span className="error-message">
                                        {errors.description?.message}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="whitebox">
                                <div className="title-text">
                                    <h3>Conclusion</h3>
                                </div>

                            <div className="createnew-box" style={{padding: '12px 19px'}}>
                                <div className="row">

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <InputControl
                                                // label="Conclusion"
                                                name="conclusion"
                                                register={register}
                                                error={
                                                    errors?.conclusion?.message
                                                }
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className='whitebox' style={{padding: '20px'}}>
                            <div className="jobdes-btn" style={{marginTop: '0px'}}>
                                <ButtonWithLoader
                                    isLoading={mutation?.isLoading}
                                    cssClass="common-btn comman-auth-btn reset-btn"
                                >
                                    {blogId ? (
                                        <button
                                            type='submit'
                                            className="common-btn create"
                                        >
                                            Save
                                        </button>
                                    ) : (
                                        <button
                                            type='submit'
                                            className="common-btn create"
                                            onClick={() =>  {setSubmitValidation(true)}}
                                        >
                                            Create
                                        </button>
                                    )}
                                </ButtonWithLoader>
                                <button
                                    type="button"
                                    className="common-btn cancel"
                                    onClick={handleCancleButton}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Form>
                </>
            )}
            <Modal
                className="modalbox"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <div className="modal-title">
                        <h3>Add Tag</h3>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        className="row"
                        onSubmit={skillhandleSubmit(handleOnSubmit)}
                    >
                        <div className="col-12">
                            <InputControl
                                label="Tag Name"
                                name="tags"
                                register={skillregister}
                                error={skillerrors.tags?.message}
                                autoComplete="off"
                            />
                        </div>

                        <div className=" col-12">
                            <div className="save">
                                <ButtonWithLoader
                                    isLoading={addnewmutation?.isLoading}
                                    cssClass="common-btn"
                                >
                                <button
                                    className="common-btn"
                                    type='button'
                                >
                                    Save
                                </button>
                                </ButtonWithLoader>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default CreateNewBlog;
